
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stud",
      function () {
        return require("private-next-pages/stud/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stud"])
      });
    }
  